import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'dmp-forbidden-error',
    templateUrl: './forbidden-error.component.html',
    styleUrls: ['./forbidden-error.component.scss'],
    standalone: false
})
export class ForbiddenErrorComponent implements OnInit {
   attemptedUrl: string | null = null;
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.attemptedUrl = params['attempted'] || null;
    });
  }

  goHome(): void {
    this.router.navigate(['/h']);
  }
}